/**
 * @generated SignedSource<<bd91801e0dc9946f97f5d8a86082e9c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailTabs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_user" | "PdpRespDealerDetails_user" | "PdpRespShippingReturns_user" | "PdpRespTabsCustomizationPanel_user">;
  readonly " $fragmentType": "PdpRespDetailTabs_user";
};
export type PdpRespDetailTabs_user$key = {
  readonly " $data"?: PdpRespDetailTabs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailTabs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutItemPanel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTabsCustomizationPanel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a416e1aab37efa8dba83302d1da8767b";

export default node;
